import Input from './Input';
export default Input;



// WEBPACK FOOTER //
// ./src/components/form/Input/index.js